<div class="row" *ngIf="totalPages > 1">
  <div class="col">
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" [ngClass]="{'disabled': currentPage==1}">
          <a class="page-link" href="javascript:void(0);" (click)="first()"><i class="fas fa-fast-backward"></i></a>
        </li>
        <li class="page-item" [ngClass]="{'disabled': currentPage==1}">
          <a class="page-link" href="javascript:void(0);" (click)="previous()"><i class="fas fa-caret-left"></i></a>
        </li>
        <li class="page-item" *ngFor="let c of blocks" [ngClass]="{'active': c === currentPage}">
          <a *ngIf="c !== currentPage" class="page-link" href="javascript:void(0);" (click)="goto(c)">{{c}}</a>
          <span class="page-link" *ngIf="c === currentPage">{{c}}</span>
        </li>
        <li class="page-item" [ngClass]="{'disabled': currentPage==totalPages}">
          <a class="page-link" href="javascript:void(0);" (click)="next()"><i class="fas fa-caret-right"></i></a>
        </li>
        <li class="page-item" [ngClass]="{'disabled': currentPage==totalPages}">
          <a class="page-link" href="javascript:void(0);" (click)="last()"><i class="fas fa-fast-forward"></i></a>
        </li>
      </ul>
    </nav>
  </div>
  <div class="col pt-2 bold">{{itemsShown}} out of {{totalCount}} shown</div>
</div>